"use strict";
/// <reference path="irep.js"/>

IREP.missions = (function () {
    var missionchoose;
    var missioncontinue;
    var selectedCharacter = "m";
    var locked = false;

    var init = function (options) {

        missionchoose = options.missionchoose;
        missioncontinue = options.missioncontinue;

        MissionUpdateCharacter();
        $("#malecharacterbutton").click(function () {
            fadeMe('m');
        });

        $("#femalecharacterbutton").click(function () {
            fadeMe('f');
        });

        $(".openMission").click(function () {
            openMission();
        });
    };

    var fadeMe = function (g) {
        if (!locked) {
            if (g === "m") {
                if (selectedCharacter !== "m") {
                    $("#femalecharacter").removeClass("selectedCharacter").addClass("deselectedCharacter");
                    $("#malecharacter").addClass("selectedCharacter").removeClass("deselectedCharacter");
                    selectedCharacter = "m";
                }
            } else {
                if (selectedCharacter !== "f") {

                    $("#malecharacter").removeClass("selectedCharacter").addClass("deselectedCharacter");
                    $("#femalecharacter").addClass("selectedCharacter").removeClass("deselectedCharacter");
                    selectedCharacter = "f";
                }
            }
        }
    };

    var openMission = function () {
        var url = "missions/insideultrabookmission?g=" + selectedCharacter; document.location = url;
    };

    var MissionUpdateCharacter = function () {

        var dataObj = {  };
        IREP.callApi("learning/mission/selectedcharacter", "GET", dataObj).done(function (data) {
            if (data !== null && data.character != null) {
                $("#buttontext").html(missioncontinue);
                fadeMe(data.character);
                $("#choosetext").html(missionchoose);
                locked = true;
            }
            else { }
        });
    };

    return {
        init: init,
        fadeMe: fadeMe
};
})();
